export const stepKeys = {
  uploading: 'uploading',
  setting: 'setting',
  preview: 'preview',
  result: 'result',
};

export const initialStep = stepKeys.uploading;
